"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.dispatchToProps = exports.stateToProps = void 0;
var redux_1 = require("redux");
var aiAgentsSelectors = __importStar(require("./store/selectors"));
var aiAgentsActions = __importStar(require("./store/actions"));
exports.stateToProps = function (state) {
    return {
        domainId: aiAgentsSelectors.getDomainId(state),
        domainName: aiAgentsSelectors.getDomainName(state),
        agentsList: aiAgentsSelectors.getAgentsList(state),
        currentAgentData: aiAgentsSelectors.getCurrentAgentData(state),
        actionsList: aiAgentsSelectors.getCurrentActionsList(state),
        currentActionData: aiAgentsSelectors.getCurrentActionData(state),
        envVariables: aiAgentsSelectors.getEnvVariables(state),
        errors: aiAgentsSelectors.getErrors(state),
        availableModels: aiAgentsSelectors.getAvailableModels(state),
    };
};
exports.dispatchToProps = function (dispatch) {
    return redux_1.bindActionCreators({
        setDomainId: aiAgentsActions.setDomainId,
        setDomainName: aiAgentsActions.setDomainName,
        setAgentsList: aiAgentsActions.setAgentsList,
        setCurrentAgentData: aiAgentsActions.setCurrentAgentData,
        setActions: aiAgentsActions.setActions,
        setCurrentActionData: aiAgentsActions.setCurrentActionData,
        setEnvVariables: aiAgentsActions.setEnvVariables,
        setErrors: aiAgentsActions.setErrors,
        setAvailableModels: aiAgentsActions.setAvailableModels,
    }, dispatch);
};
